module.exports = __webpack_public_path__ + "img/cg_foldup.0c6d3426.png";